import { audio } from '../systems/audio/AudioSystem.js';

/**
 * Shown once, right after the last boss before the King dies (The Jealous
 * Regent since the 2026-07 gauntlet expansion) — the one deliberate
 * exception to every other gauntlet transition being instant (see Game.js's
 * _onBossDied/_beginFinalWaveStage). Holds until the player clicks
 * Proceed, then starts the final boss's wave stage.
 */
export class FinalWarningOverlay {
  constructor(eventBus, root, { onContinue }) {
    this.root = root;
    this.onContinue = onContinue;
    this.el = null;
    eventBus.on('gauntlet:final-warning', ({ defeatedName, name }) => this._show(defeatedName, name));
  }

  _show(defeatedName, name) {
    const isUndersong = name === 'The Undersong';
    const el = document.createElement('div');
    el.className = 'menu-overlay final-warning-overlay';
    el.innerHTML = `
      <div class="final-warning-title">${isUndersong ? 'DESCENT COMPLETE' : 'WARNING'}</div>
      <div class="final-warning-tagline">${isUndersong ? 'There is no throne at the bottom. Only the first silence.' : `${defeatedName} was only ever a fragment.`}</div>
      <div class="final-warning-name">${name.toUpperCase()}</div>
      ${isUndersong ? '<div class="final-warning-tagline">The dark has learned your shape.</div>' : ''}
    `;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'menu-button menu-button-primary';
    button.textContent = 'Proceed';
    button.addEventListener('click', () => {
      audio.playSfx('click');
      this._hide();
      this.onContinue();
    });
    el.appendChild(button);
    this.root.appendChild(el);
    this.el = el;
  }

  _hide() {
    this.el?.remove();
    this.el = null;
  }
}
